import { Footer } from "./footer";
import { Navbar } from "./navbar";

export function ContentLayout({ title, children }) {
  return (
    <div>
      <Navbar title={title} />
      <div className="pt-8 pb-8 px-4 sm:px-8 min-h-[calc(100vh-114px)]">
        {children}
      </div>
      <Footer />
    </div>
  );
}
